import { atom, getDefaultStore, type PrimitiveAtom } from "jotai";
import { useMemo } from "react";
import { v4 } from "uuid";

import type { GeneralSupportSection, SpecialSupportSection } from "./types";
const store = getDefaultStore();
export const OnMouseOver = Symbol("SpecialSupportVisibleOnHover");

export const SUPPORT_TRANSITION_MS = 500;
export const SUPPORT_TRANSITION_EASING = "cubic-bezier(0.22, 1, 0.36, 1)";

// Set in atom
export function writeAtom<T>(atom: PrimitiveAtom<T>, value: T) {
    store.set(atom, value);
}

// Generals support
export const generalsAtom = atom<GeneralSupportSection | null>(null);

export function createGeneralSupportSection(id: string): GeneralSupportSection {
    return {
        id,
        element: atom<HTMLDivElement | null>(null),
    };
}

export function useGeneralSupportSection(id: string) {
    return useMemo(() => createGeneralSupportSection(id), [id]);
}

// Special support
export const specialsAtom = atom<Array<SpecialSupportSection>>([]);

export function createSpecialSupportSection(): SpecialSupportSection {
    return {
        id: v4(),
        element: atom<HTMLDivElement | null>(null),
        offset: atom<number | null>(null),
        height: atom<number | null>(null),
        visible: atom<boolean>(false),
    };
}

export function useSpecialSupportSection() {
    return useMemo(() => createSpecialSupportSection(), []);
}

export const specialHoveredAtom = atom<SpecialSupportSection | null>(null);

export const specialActiveAtom = atom((get) =>
    get(specialsAtom).some((section) => get(section.visible)),
);
